export const t = { "en": { "colorPicker": { "favorites": "Favorites", "popover": { "mode": { "simple": "Simple", "advanced": "Advanced" }, "edit": "Edit", "reset": "Reset to default" } } } };
export const d = [];